module.exports = __webpack_public_path__ + "static/assets/034ca52c00b832443da9533a99ae3fd4.png";